var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOthers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#BB71E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM24.1276 16.9119C23.7888 19.9616 21.7736 22.5055 19.0244 23.6014C19.9096 21.7971 20.4269 19.4474 20.5269 16.9119H24.1276ZM18.7069 16.9119C18.5737 19.9764 17.7736 22.6847 16.5262 24.1632C16.351 24.1744 16.1743 24.18 15.9963 24.18C15.8202 24.18 15.6454 24.1745 15.4721 24.1635C14.2246 22.6851 13.4243 19.9767 13.2911 16.9119H18.7069ZM11.4711 16.9119C11.5712 19.4487 12.089 21.7995 12.975 23.6041C10.2222 22.5097 8.20405 19.9641 7.8649 16.9119H11.4711ZM13.2908 15.0938H18.7072C18.5749 12.0248 17.7737 9.31221 16.5242 7.83317C16.3497 7.82205 16.1736 7.81641 15.9963 7.81641C15.8209 7.81641 15.6468 7.82192 15.4741 7.8328C14.2245 9.31176 13.4232 12.0245 13.2908 15.0938ZM12.9763 8.39179C12.0887 10.1984 11.5703 12.553 11.4709 15.0938H7.86388C8.20004 12.0369 10.2201 9.487 12.9763 8.39179ZM24.1287 15.0938H20.5272C20.4278 12.5543 19.9099 10.2008 19.023 8.39451C21.7757 9.49122 23.7928 12.0395 24.1287 15.0938Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOthers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OTHERS.b7b988f26858aa874a1b7487020eeb31.svg";